module.exports = __webpack_public_path__ + "img/MyGymChecker-Logo-PNG-WhiteBlue.5b3b94bb.png";